import { UseMutateAsyncFunction, useMutation, useQueryClient } from "@tanstack/react-query"
import { LIST_USER_INVITATIONS } from "../../../constants"
import { TriggerToast } from "../../globals/Toaster"
import { useWorkspaceService } from "../services/useWorkspaceService"
import { invalidateActivityQueries } from "../../../utils/queryInvalidation"

type RejectInviteProps = {
  workspaceId: string
  email: string
}

type UseRejectInviteType = UseMutateAsyncFunction<{ message: string }, unknown, RejectInviteProps, unknown>

const useRejectInvite = (): UseRejectInviteType => {

  const queryClient = useQueryClient()
  const workspaceService = useWorkspaceService()

  const { mutateAsync: rejectInviteMutation } = useMutation({
    mutationFn: async (params: RejectInviteProps) => {
      return workspaceService.cancelInvite(params.workspaceId, params.email)
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [LIST_USER_INVITATIONS], refetchType: "active" }),
        invalidateActivityQueries(queryClient),
      ])
      TriggerToast("Workspace invite rejected successfully.", undefined, 'success')
    },
    onError: () => {
      TriggerToast("Failed to reject workspace invite.", undefined, 'error')
    },
  })

  return rejectInviteMutation
}

export default useRejectInvite
